/** ***********************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import {getLocalizedURL} from '@intl/adobe-locales';
import React, {Component} from 'react';
import {RecentAssetsAnalytics} from 'recent-files';
import {getEnvironment} from '../../../../../utils/Environment';
import {Utils} from '../../../../../utils/Globals';
import StoreUtils from '../../../../../utils/StoreUtils';
import {newCanvasLinks} from '../../../../containers/AppHome/appHomeData';
import './EmptyState.scss';

/*
 * FredEmptyState is the view displayed in the UI when empty(s) occur.
 */
type Props = {
	linkClick: Function;
};

type State = {
	hideLink: boolean;
};

class FredEmptyState extends Component<Props, State> {
	constructor(props: Props) {
		super(props);
		try {
			this.state = {
				// @ts-ignore
				hideLink: !StoreUtils.store.getState().appHome.ccProjectsFetchFinished,
			};
			// @ts-ignore
			StoreUtils.store.subscribe(() => {
				// @ts-ignore
				if (this.state.hideLink === StoreUtils.store.getState().appHome.ccProjectsFetchFinished) {
					// @ts-ignore
					this.setState({hideLink: !StoreUtils.store.getState().appHome.ccProjectsFetchFinished});
				}
			});
		}
		catch (err) {
			// do nothing
		}
	}

	componentDidMount() {
		this.addEventListenerToElemId('empty-state-fred-new-canvas', 'click', this.handleNewCanvasClick);
	}

	addEventListenerToElemId(elemId: string, eventType: string, callback: EventListenerOrEventListenerObject) {
		const elem = document.getElementById(elemId);
		if (elem) {
			elem.addEventListener(eventType, callback);
		}
	}

	handleNewCanvasClick = (e) => {
		e.preventDefault();
		this.props.linkClick();
		const url = getLocalizedURL(newCanvasLinks[getEnvironment()].FRED);
		const analytics = new RecentAssetsAnalytics();
		const analyticsPromise = analytics.postEmptyPageClick('new-file', url);
	};

	render() {
		return (
			<div className='empty-state-app-home empty-state-fred-container' role='region'>
				<img style={{width: '160px'}} src='/assets/common/CanvasDrop.svg' />
				<h2
					className='empty-state-psweb-heading'
					dangerouslySetInnerHTML={{__html: Utils.localizedStrings['recents.fred.emptystate.heading']}}
				/>
				<div
					className={`empty-state-psweb-description ${
						this.state && this.state.hideLink ? 'hide-fred-link' : ''
					}`}
					dangerouslySetInnerHTML={{__html: Utils.localizedStrings['recents.fred.emptystate.description']}}
				/>
			</div>
		);
	}
}

export default FredEmptyState;
